export const TOP_NAV_HEIGHT = 60
export const SIDEBAR_WIDTH = 240
export const SIDEBAR_WIDTH_COLLAPSED = 60
export const RIGHT_SIDEBAR_WIDTH = 300
export const RIGHT_SIDEBAR_WIDTH_COLLAPSED = 40
export const CONTENT_BG = '#f8f8fa'
